const WIN_ANSI_EXTRAS = new Set(
  [0x20ac, 0x201a, 0x0192, 0x201e, 0x2026, 0x2020, 0x2021, 0x02c6,
   0x2030, 0x0160, 0x2039, 0x0152, 0x017d, 0x2018, 0x2019, 0x201c,
   0x201d, 0x2022, 0x2013, 0x2014, 0x02dc, 0x2122, 0x0161, 0x203a,
   0x0153, 0x017e, 0x0178],
);

/** Standard PDF text authoring cannot safely generate appearances for other scripts. */
export function unsupportedPdfTextCharacters(text: string): string[] {
  return [...new Set([...text].filter((character) => {
    const code = character.codePointAt(0)!;
    return !([9, 10, 13].includes(code) || (code >= 32 && code <= 126) ||
      (code >= 160 && code <= 255) || WIN_ANSI_EXTRAS.has(code));
  }))];
}

export function pdfTextSupportError(text: string): string | null {
  const unsupported = unsupportedPdfTextCharacters(text);
  if (unsupported.length === 0) return null;
  const codes = unsupported.slice(0, 8).map((character) =>
    `U+${character.codePointAt(0)!.toString(16).toUpperCase().padStart(4, "0")}`,
  ).join(", ");
  return `PDF text authoring cannot render these characters (${codes}) with its supported fonts. No changes were applied. Use a supported Latin spelling only if the user supplies or approves it; do not silently omit or transliterate characters.`;
}
